import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { COUNTRY_CODE_US, HEADERS_GEO_CLIENT_COUNTRY, HEADERS_GEO_CLIENT_IP } from '@constants/app.constants';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeadersService {
  constructor(private http: HttpClient) {}

  getHeadersFromHomeRoute() {
    return this.http
      .get('/', { observe: 'response', responseType: 'text' })
      .pipe(
        map((response) => {
          return {
            geoClientCountry: response.headers.get(HEADERS_GEO_CLIENT_COUNTRY) || COUNTRY_CODE_US,
            geoClientIp: response.headers.get(HEADERS_GEO_CLIENT_IP),
          };
        }),
      );
  }
}
